import { useToast } from '@chakra-ui/react'
import { useState } from 'react'

import { requestApi } from '../api/request-handler'

export type StatusType = 'success' | 'error'

export const useResetPassword = () => {
  const [sending, setSending] = useState(false)
  const toast = useToast()

  const sendPWResetRequest = (status: StatusType, userId: string) => {
    toast({
      title: `Password reset for ${userId} ${status === 'success' ? 'was successful' : 'failed'}`,
      status: status,
      duration: 3000,
    })
  }

  const resetPWRequest = async (userId?: string) => {
    setSending(true)

    if (!userId) {
      sendPWResetRequest('error', 'Unknown user')
    } else {
      try {
        const response = await requestApi(`admin/users/${userId}/reset-password`, {
          method: 'PUT',
        })
        if (response) {
          setSending(false)
          sendPWResetRequest(response.ok ? 'success' : 'error', userId)
        }
      } catch (error) {
        console.warn('Error resetting password', error) // eslint-disable-line no-console
        setSending(false)
        sendPWResetRequest('error', userId)
      }
    }
  }

  return {
    sending,
    resetPWRequest,
  }
}
